import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {RecipientFilterCriteria} from '../../models/filter/recipient-filter-criteria';
import {AnnouncementService} from '../../services/announcement.service';
import {ActivatedRoute} from '@angular/router';
import {Announcement} from '../../models/announcement';
import {Recipient} from '../../models/recipient';
import {Column} from '../../share/models/column';
import * as _ from 'lodash';
import {UtilsService} from '../../appSharedModule/services/utils.service';

@Component({
  selector: 'app-list-recipients',
  templateUrl: './list-recipients.component.html',
  styleUrls: ['./list-recipients.component.scss']
})
export class ListRecipientsComponent implements OnInit {

  recipientFilterCriteria: RecipientFilterCriteria;
  recipientsList: Recipient[];
  filteredRecipientsList: Recipient[];
  cols: Column[];
  companies: string;
  announcement: Announcement;
  size: number;

  userChoicesFiltersDefaultRecipientList = {
    company: '',
    recipientName: '',
    email: ''
  };
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultRecipientList);

  constructor(private authenticationService: AuthenticationService,
              private announcementService: AnnouncementService,
              private utilsService: UtilsService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('recipientListFilter', this.userChoicesFiltersDefaultRecipientList);
    this.recipientFilterCriteria = new RecipientFilterCriteria(null, null, null);
    this.cols = [
      {field: 'company', header: 'Company', type: 'string', sortable: true, width: '30%'},
      {field: 'recipientName', header: 'Recipient name', type: 'string', sortable: true, width: '30%'},
      {field: 'email', header: 'Email', type: 'string', sortable: false, width: '40%'},
    ];
    this.recipientsList = [];
    this.route.paramMap.subscribe(params => {
      const announcementId = params.get('announcementId');
      this.announcementService.getAnnouncement(Number(announcementId))
        .subscribe((announcements) => {
          this.announcement = announcements;
          this.getListRecipients();
          this.getListCompanies();
        });
    });
  }

  getListRecipients() {
    this.announcement.user.forEach(
      (user) => {
        this.recipientsList.push({company: user.company.name, recipientName: user.name, email: user.emailShown});
      });
    this.filter();
  }

  getListCompanies() {
    const comp = [];
    this.announcement.company.forEach(
      (company) => {
        comp.push(company.name);
      });
    this.companies = comp.join(', ');
  }

  filter() {
    this.utilsService.saveUserData('recipientListFilter',
      {
        company: this.recipientFilterCriteria.company,
        recipientName: this.recipientFilterCriteria.recipientName,
        email: this.recipientFilterCriteria.email
      });
    const filter = this.recipientFilterCriteria;
    this.filteredRecipientsList = [];
    this.filteredRecipientsList = this.recipientsList.filter(
      function (recipient) {
        return (!filter.company || recipient.company.toLowerCase().includes(filter.company.toLowerCase()))
          && (!filter.recipientName || recipient.recipientName.toLowerCase().includes(filter.recipientName.toLowerCase()))
          && (!filter.email || recipient.email.toLowerCase().includes(filter.email.toLowerCase()));
      });
    this.size = this.filteredRecipientsList.length;
  }

  reset() {
    this.recipientFilterCriteria = new RecipientFilterCriteria(null, null, null);
    this.filter();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }
}
